/* import __COLOCATED_TEMPLATE__ from './date-step.hbs'; */
import { RESERVATION_TIME } from 'client-portal/utils/prescreener/preview';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestStepsDateStep extends Component {
  @service session;
  @service prescreener;

  get reservation() {
    if (this.prescreener.preview.isPreview) {
      return RESERVATION_TIME;
    }
    return this.args.model;
  }
}
